import React from "react";
const Footer = () => {
  return (
    <div>
      <div
        className="footer"
        style={{
          textAlign: "center",
          marginTop: "30px",
          fontWeight: "bold",
        }}
      >
        Made with <span style={{ color: "red" }}>❤</span> by Ayush Singh
      </div>
    </div>
  );
};

export default Footer;
